import { render } from "./sim-position.vue?vue&type=template&id=51b47183&scoped=true"
import script from "./sim-position.vue?vue&type=script&lang=js"
export * from "./sim-position.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-51b47183"

export default script